/*
 * Meetings Messages
 *
 * This contains all the text for the Meetings component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.Meetings.header',
    defaultMessage: 'Parent Meetings',
  },
  create: {
    id: 'app.components.Meetings.create',
    defaultMessage: 'Plan Parent Meetings',
  },
  noMeetings: {
    id: 'app.components.Meetings.noMeetings',
    defaultMessage: 'No parent meetings planned',
  },
  meetingLocationType: {
    id: 'app.components.Planner.meetingLocationType',
    defaultMessage: 'Location',
  },
  selectLocationType: {
    id: 'app.components.ParentPlanner.selectLocationType',
    defaultMessage: 'Select a location for the meeting',
  },
  onPremises: {
    id: 'app.components.Planner.onPremises',
    defaultMessage: 'On Premises',
  },
  videoMeeting: {
    id: 'app.components.Planner.videoMeeting',
    defaultMessage: 'Video Conference',
  },
  videoExplain1: {
    id: 'app.components.Planner.videoExplain1',
    defaultMessage: 'Video conferences take place using <b>Microsoft Teams</b> or <b>Google Meet</b>.',
  },
});
